module.exports = __webpack_public_path__ + "img/banner2.c527286f.png";